'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateURL = validateURL;
var error = exports.error = function error(message) {
  throw new Error(message);
};

function validateURL(params) {
  var names = Object.keys(params);
  names.map(function (name) {
    var url = params[name];
    if (!url) {
      error(name + ' is Undefined!!!!!!!!!!');
    }
    if (url && typeof url !== 'string') {
      error('If ' + name + ' exist. Must be string');
    }
    return name;
  });
}

exports.default = { validateURL: validateURL };


/*****************
 ** WEBPACK FOOTER
 ** ./~/@mayo/login-pass/lib/helper/validateHelper.js
 ** module id = 2257
 ** module chunks = 30 33 69 71
 **/